import React from 'react'
import Cursor1 from '../components/curs1/Cursor1'
import Cursor from '../components/curs/Cursor'
import { ToastContainer, toast } from 'react-toastify';
import { useState } from 'react'


const Home = () => {
  const [email, setEmail] = useState('')  
  const onChange = (e) => {
    setEmail(e.target.value)
  }
  const onSubmit = (e) => {
      e.preventDefault();
      (email === '' ? toast.error("Email est invalide!") 
      : toast.success("Votre inscription à notre s'est déroulée avec succès!"))
    }


  return (
    <>
        <Cursor1 />

        <div className="par1">
          <div className='par1-1'>
             <h1>ABONNEZ VOUS À NOTRE BTTUS_NEW</h1>
             <p>& Profitez de 5% de remise pour votre première commande</p>
          </div>
          <div className='par1-2'>
            <div className='lesIcons'>
              <div className='listIcon'>
                  <div className="nombre child">1</div>
                  <div className='child'>
                    <i className="fas fa-truck fa-2x"></i>
                    <span className="offer">Livraison Gratuite</span>
                  </div>
              </div>

              <div className='listIcon'>
                <div className="nombre child">2</div>
                <div className='child'>
                  <i class="fas fa-money fa-2x"></i>
                  <span className="offer">Pays en Ligne</span>
                </div>
              </div>

              <div className='listIcon'>
                <div className="nombre child">3</div>
                <div className='child'>
                  <i class="fas fa-phone fa-2x"></i>
                  <span className="offer">Appelez-nous</span>
                </div>
              </div>

              <div className='listIcon'>
                <div className="nombre child">4</div>
                <div className='child'>
                  <i class="fas fa-gift fa-2x"></i>
                  <span className="offer">Gagner des récompenses</span>
                </div>
              </div>
            </div>  

            <div>
              <form onSubmit={onSubmit} className='Inscrire'>
                <input onChange={onChange} value={email} type="email" placeholder='Entrez votre email' />
                <button>S'INSCRIRE</button>
              </form>
              {/* {alert === false && <div className='alertInsc'>Email is invalid</div>} */}
              <ToastContainer />
            </div>      
          </div>
        </div>        
        <Cursor />
    </>
  )
}

export default Home